// Case-insensitive highlighter for admin table / list cells.
//
// Splits `text` by `query` and wraps every match in <mark>. Keeps the
// rest of the text as plain spans so screen-readers still see one
// continuous string. Escapes regex metacharacters in the query so a
// user typing "." or "+" doesn't blow up the match.

const ESC_RE = /[.*+?^${}()|[\]\\]/g;

export default function Highlight({
  text,
  query,
  className = "bg-yellow-200 text-neutral-950 rounded-sm px-0.5",
}) {
  const t = text == null ? "" : String(text);
  const q = (query || "").trim();
  if (!q || !t) return <>{t}</>;
  const esc = q.replace(ESC_RE, "\\$&");
  const parts = t.split(new RegExp(`(${esc})`, "gi"));
  const qLower = q.toLowerCase();
  return (
    <>
      {parts.map((p, i) =>
        p && p.toLowerCase() === qLower ? (
          <mark key={i} className={className} data-testid="search-hit">{p}</mark>
        ) : (
          <span key={i}>{p}</span>
        )
      )}
    </>
  );
}
